<template>
    <div>
        <div class="search_head">
            <a-form layout="inline" style="padding: 0">
                <a-form-item label="语种">
                    <a-select v-model="language" :options="languages" style="width:250px"></a-select>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" html-type="submit" @click="loadtable()">
                        搜索
                    </a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="search_content">
            <a-table :columns="columns" :data-source="table" bordered size="small" :loading="loading"
                :rowKey="(record, index) => { return index }">

            </a-table>
        </div>
    </div>
</template>
<script>
import { get, post } from "../../assets/js/request";
export default {
    data() {
        return {
            table: [],
            language: 'cn',
            languages: [
                {
                    label: "中文",
                    value: "cn"
                },
                {
                    label: "英文",
                    value: "en"
                }],
            columns: [
                {
                    title: '序号',
                    customRender: (text, record, index) => `${index + 1}`,
                    width: 50,
                },
                {
                    title: "语种",
                    dataIndex: "language",
                }, {
                    title: "名称",
                    dataIndex: "name",
                },
                , {
                    title: "性别",
                    dataIndex: "gender",
                }, {
                    title: "code",
                    dataIndex: "audioCode",
                }
            ],
            loading: false,
        };
    },
    created() {
        this.loadtable();
    },
    methods: {
        loadtable() {
            this.loading = true;
            get("/public/audios", {
                language: this.language,
            }).then((res) => {
                this.loading = false;
                this.table = res.data;
            });
        }

    },
};
</script>